import { encrypt, decrypt } from '@/utils/crypto.js';

const aesKey = 'HDBOWYdR73eWjOps';

export const aesInterfaceParams = (url,params)=> {
  const urlWhiteList = ['/api/v1/auth/token','/api/v1/auth/send-verify-code','/api/v1/auth/register',
                      '/api/v1/auth/find-pwd','/api/v1/auth/user/update','/api/v1/auth/user/send-verify-code'];
  let aesParams = params;

  if (urlWhiteList.indexOf(url) >= 0) {
    aesParams = getAesParams(params);
  }

  return aesParams;
};


export const getAesParams = (params)=> {
  const keyWhiteList = ['account','email','phone','password','old_password','old_phone','old_email','valid_password'];
  let aesParams = params;

  for(let i=0; i<keyWhiteList.length; i++) {
    let key = keyWhiteList[i];
    let keyData = aesParams[key];

    if (!!keyData) {
      let aesStr = encrypt(keyData, aesKey);

      if (aesStr) {
        aesParams[key] = aesStr;
      }
    }
  }

  return aesParams;
};


// WEBPACK FOOTER //
// ./src/server/aes-interface.js